import React from 'react';
import { Bell, Menu } from 'lucide-react';
import { ThemeSwitcher } from './ThemeSwitcher';
interface PageHeaderProps {
  onOpenMobileMenu?: () => void;
}
export function PageHeader({
  onOpenMobileMenu
}: PageHeaderProps) {
  return <header className="h-[68px] bg-white/80 dark:bg-dark-surface/80 backdrop-blur-xl border-b border-gray-200/60 dark:border-dark-subtle flex items-center justify-between lg:justify-end px-4 lg:px-8 sticky top-0 z-20 transition-colors duration-180" data-id="element-604">
      {/* Mobile Menu Button */}
      <button onClick={onOpenMobileMenu} className="lg:hidden p-2 -ml-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-hover rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500" aria-label="Open menu" data-id="element-605">
        <Menu className="w-6 h-6" data-id="element-606" />
      </button>

      <div className="flex items-center space-x-2" data-id="element-607">
        <ThemeSwitcher data-id="element-608" />

        <button className="p-2 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark-hover rounded-lg transition-all duration-180 relative focus:outline-none focus:ring-3 focus:ring-blue-100 dark:focus:ring-blue-900" data-id="element-609">
          <Bell className="w-5 h-5" data-id="element-610" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white dark:border-dark-surface" data-id="element-611"></span>
        </button>

        <div className="w-px h-6 bg-gray-200 dark:bg-dark-medium mx-2 hidden sm:block" data-id="element-612"></div>

        <img src="https://media.licdn.com/dms/image/v2/D4D03AQHdjvBZrrPISg/profile-displayphoto-shrink_400_400/profile-displayphoto-shrink_400_400/0/1730625193571?e=1766620800&v=beta&t=4YCT3uKkbDoHARy0fsSpLWPAppdswN1VICI-ZXWsRyk" alt="Fabio Gai" className="w-8 h-8 rounded-full object-cover shadow-sm hover:shadow-md transition-all duration-180 focus:outline-none focus:ring-3 focus:ring-blue-100 dark:focus:ring-blue-900 cursor-pointer hidden sm:block" data-id="element-613" />
      </div>
    </header>;
}